(function() {
  'use strict';

  /**
   * AngularJS directive that works as a bridge for Angular router-link
   * This directive allows using router-link in AngularJS templates by directly
   * using Angular's Router service
   */
  function routerLink(Router, LocationStrategy, RouterHelper) {
    return {
      restrict: 'A',
      scope: {
        routerLink: '<',
        queryParams: '<?',
        routerState: '<?',
        target: '@?'
      },
      link: function(scope, element) {
        const isAnchorElement = element[0].tagName.toLowerCase() === 'a';
        let currentUrl;

        function updateUrlTree() {
          if (!scope.routerLink) {
            return null;
          }

          const commands = Array.isArray(scope.routerLink) ? scope.routerLink : [scope.routerLink];
          return Router.createUrlTree(commands, {
            queryParams: scope.queryParams
          });
        }

        function updateHref() {
          const urlTree = updateUrlTree();
          if (urlTree && isAnchorElement) {
            const url = LocationStrategy.prepareExternalUrl(Router.serializeUrl(urlTree));
            if (url !== currentUrl) {
              currentUrl = url;
              element.attr('href', url);
            }
          }
        }

        scope.$watch('routerLink', updateHref);
        scope.$watch('queryParams', updateHref);

        element.on('click', function(e) {
          // Only handle left clicks
          if (e.button !== 0) {
            return;
          }

          // Let browser handle target=_blank etc.
          if (isAnchorElement && scope.target && scope.target !== '_self') {
            return;
          }

          // Don't handle clicks with modifier keys
          if (e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
          }

          const urlTree = updateUrlTree();
          if (!urlTree) {
            return;
          }

          e.preventDefault();
          scope.$apply(() => {
            // If we have router state, pass it via RouterHelper
            if (scope.routerState) {
              RouterHelper.setState(scope.routerState);
            }
            Router.navigateByUrl(urlTree);
          });
        });
      }
    };
  }

  routerLink.$inject = ['Router', 'LocationStrategy', 'RouterHelperService'];

  angular
    .module('blocks.router', [])
    .directive('routerLink', routerLink);
})();
